export default "__VITE_ASSET__AbIhaNn3__"